module.exports = __webpack_public_path__ + "static/media/empty13_mywork1_anim.99db7972.svg";